<template>

  <v-btn
    :loading="isLoading"
    v-bind="computedProps"
    v-on="computedListeners">
    <slot></slot>
  </v-btn>

</template>
<script>
/**
 * @file DDv2用標準ボタン
 * @namespace components
 */

/**
 * @vue-event {Object} click
 * @see https://vuetifyjs.com/ja/api/v-btn/
 * @example
<dd-default-button
  [atmark]click="DbDefaultButtonOnClick">
  検索
</dd-default-button>
 */
export default {
  name: 'DdDefaultButton',
  props: {
    block: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
  }),
  computed: {
    computedProps () {
      return {
        ...this.$props,
        block: this.block,
        dark: true,
        dense: true,
        color: '#2196F3',
        minWidth: 80
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    }
  },
  mounted: function () {
  },
  methods: {
  }
}
</script>
<style scoped>
i::before {
  color: #1976d2 !important;
}
</style>
